/**
 * WordPress dependencies
 */
export * from '@wordpress/block-editor';

import type {
	StoreDescriptor,
	ReduxStoreConfig,
} from '@wordpress/data/build-types/types';
import { BlockInstance } from '@wordpress/blocks';

import { store as blockEditorStore } from '@wordpress/block-editor';
export const store = blockEditorStore as unknown as StoreDescriptor<
	ReduxStoreConfig<
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		any,
		{
			readonly __unstableMarkNextChangeAsNotPersistent: () => void;
			readonly updateBlock: (
				clientId: string,
				attributes: Record< string, unknown >,
				options?: Record< string, unknown >
			) => void;
			readonly replaceBlocks: (
				clientIds: string[],
				blocks: BlockInstance[]
			) => void;
		},
		{
			readonly getBlock: (
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				state: any,
				clientId: string
			) => BlockInstance | null;
			readonly getBlocksByClientId: (
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				state: any,
				clientIds: string | string[]
			) => Array< BlockInstance | null >;
			readonly getClientIdsOfDescendants: (
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				state: any,
				clientIds: string[]
			) => string[];
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			readonly getClientIdsWithDescendants: ( state: any ) => string[];
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			readonly getBlocks: ( state: any ) => BlockInstance[];
			readonly getBlockParentsByBlockName: (
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				state: any,
				clientId: string,
				blockName: string | string[],
				ascending: boolean
			) => ReadonlyArray< string >;
			readonly isBlockHighlighted: (
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				state: any,
				clientId: string
			) => boolean;
			readonly isDraggingBlocks: (
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				state: any
			) => boolean;
			readonly isBlockSelected: (
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				state: any,
				clientId: string
			) => boolean;
			readonly hasSelectedInnerBlock: (
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				state: any,
				clientId: string,
				deep?: boolean
			) => boolean;
		}
	>
>;
